import React from 'react';
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img1 from "../../../images/landing/html-css.webp";
import Img2 from "../../../images/landing/JavaScript.webp";
import Img3 from "../../../images/landing/React.webp";
import Img4 from "../../../images/landing/jQuery.webp";
import Img5 from "../../../images/landing/Angular.webp";
import Img6 from "../../../images/landing/Laravel.webp";
import Img7 from "../../../images/landing/java.webp";
import Img8 from "../../../images/landing/Ruby.webp";
import Img9 from "../../../images/landing/c-sharp.webp";
import Img10 from "../../../images/landing/MySQL.webp";
import Img11 from "../../../images/landing/Mongo_DB.webp";
import Img12 from "../../../images/landing/oracale.webp";
import Img13 from "../../../images/landing/sublime.webp";
import Img14 from "../../../images/landing/visual_studio.webp";
import Img15 from "../../../images/landing/atom.webp";
import Img16 from "../../../images/landing/codepen.webp";
import Img17 from "../../../images/landing/Windows.webp";
import Img18 from "../../../images/landing/macOS.webp";
import Img19 from "../../../images/landing/Linux.webp";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section lp_stack p-100 hv-100" style={{ backgroundColor: "#F8F8FB" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} className="my-auto">
            <Row>
              <Col xs={12} md={8} lg={10} xl={8} className="m-auto text-center">
                <h3 className="h3_head">Tech-stack for Our Website Development Firm</h3>
                <p>As an experienced website development firm, we understand the significance of the latest technologies to give a competitive edge to clients in the market. We deploy evolving technologies to build innovative web solutions ensuring rich feature-based functionalities.</p>
              </Col>
            </Row>
            <Row className="landing_show_mobile">
          <Col xs={12} md={6} lg={6}>
            <h4>Front-end</h4>
            <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">HTML & CSS</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img2}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">JavaScript</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img3}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">React</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img4}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">jQuery</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img5}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Angular</div></li>
              </ul>
            <h4>Back-end</h4>
            <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img6}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">PHP (Laravel)</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img7}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Java</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img8}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Ruby</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img9}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">C#</div></li>
              </ul>
            <h4>Databases</h4>
            <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img10}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">MySQL</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img11}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">MongoDB</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img12}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Oracle Database</div></li>
              </ul>
            <h4>Tools</h4>
            <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img13}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Sublime Tex</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img14}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Visual Studio Code</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img15}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Atom</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img16}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">CodePen</div></li>
              </ul>
            <h4>Operating Systems</h4>
            <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img17}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Microsoft Windows</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img18}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">macOS</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img19}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Linux</div></li>
              </ul>
          </Col>
        </Row>
        <Row className="landing_show_desktop">
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Front-end">
              <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img1}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">HTML & CSS</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img2}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">JavaScript</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img3}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">React</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img4}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">jQuery</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img5}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Angular</div></li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Back-end">
              <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img6}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">PHP (Laravel)</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img7}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Java</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img8}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Ruby</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img9}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">C#</div></li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Databases">
              <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img10}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">MySQL</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img11}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">MongoDB</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img12}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Oracle Database</div></li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Tools">
              <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img13}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Sublime Tex</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img14}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Visual Studio Code</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img15}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Atom</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img16}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">CodePen</div></li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Operating Systems">
              <ul>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img17}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Microsoft Windows</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img18}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">macOS</div></li>
                <li>
                  <div className="tabs_img_lp"><LazyLoadImage
                    src={Img19}
                    effect="blur"
                    alt="TekRevol"
                    className="img-fluid"
                  />
                  </div>
                  <div className="li_white_text">Linux</div></li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
